import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ChromeService } from '../_services/chrome.service';
@Component({
  selector: 'app-app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.css']
})
export class AppShellComponent {
  isSidebarOpen$: Observable<boolean>;

  constructor(private readonly chrome: ChromeService) {
    this.isSidebarOpen$ = this.chrome.isSidebarOpen$;
  }

}
